import apiV2 from './apiV2';

export interface LiveQuestionState {
  revision: number;
  question: string;
  revealed_name: string;
  active?: boolean;
  selected?: { id?: number; name?: string };
  selected_count?: number;
  remaining_count?: number;
}

export type QuestionAction = 'show' | 'draw' | 'reveal' | 'hide_name' | 'clear';
export const liveQuestionApi = {
  get: (runId: number, teacher: boolean) => apiV2.get<LiveQuestionState>(
    `/lesson-runs/${runId}/verbal-question/${teacher ? '' : '?display=1'}`,
  ).then(response => response.data),
  command: (runId: number, revision: number, action: QuestionAction, question?: string) =>
    apiV2.post<LiveQuestionState>(`/lesson-runs/${runId}/verbal-question/`, {
      revision, action, ...(question === undefined ? {} : { question }),
    }).then(response => response.data),
};
